import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getLandingPageData from 'store/landing/selector/getLandingPageData';
import getSearchQuery from 'store/search/selector/getSearchQuery';
import { LandingPageProvider } from 'context/LandingPageContext';
import LandingPageBuilder from 'components/LandingPage/Factory/LandingPageBuilder';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmNoSearchResultsEvent from 'utils/gtm/gtmNoSearchResultsEvent';
import styles from './NoResults.module.scss';

const NoResults = () => {
  const { t } = useTranslation();
  const currentQuery = useSelector(getSearchQuery);
  const landingPageData = useSelector(getLandingPageData);

  useEffect(() => {
    gtmSendEvent(gtmNoSearchResultsEvent(currentQuery));
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.lpContainer}>
        {landingPageData && landingPageData.content && (
          <LandingPageProvider>
            <LandingPageBuilder landingPageData={landingPageData} />
          </LandingPageProvider>
        )}
      </div>
    </div>
  );
};

export default NoResults;
